<template>
  <v-app>
    <!-- Snackbar -->
    <v-snackbar
      top
      v-model="snackbar"
      timeout="10000"
      color="sokoDeep"
      transition="slide-y-transition"
    >
      {{ snackbarMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- End Snackbar -->
    <v-app-bar
      app
      :color="appBarProps.color"
      :dark="appBarProps.isDark"
      depressed
      class="px-2"
    >
      <!-- Brand -->
      <router-link to="/" style="text-decoration: none; color: #000">
        <v-img
          :src="require('./assets/sd-logo.svg')"
          :srcset="require('./assets/sd-logo.png')"
          contain
          width="180"
          alt="Brand"
        />
      </router-link>

      <v-spacer></v-spacer>

      <!-- Display navbar action components - show on desktop screens and above -->
      <div
        class="text-center d-none d-md-block d-lg-block d-xl-block"
        v-if="$route.path !== '/auth'"
      >
        <!-- Show user account icon when user is logged in but signup and login if not logged in -->
        <template v-if="!isLoggedIn">
          <v-btn
            rounded
            class="ma-1"
            color="sokoDeep"
            depressed
            dark
            @click="openLogin"
            >Login</v-btn
          >
          <v-btn rounded color="sokoDeep--text" depressed @click="openSignup"
            >Sign up</v-btn
          >
        </template>

        <template v-else-if="userDetails.fname">
          <!-- User button -->
          <v-menu
            bottom
            left
            offset-y
            origin="top right"
            transition="scale-transition"
            close-on-click
            nudge-bottom="5"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                class="ml-4"
                :class="{
                  'sokoPrimary font-weight-bold': !userDetails.photourl,
                }"
                v-bind="attrs"
                v-on="on"
                size="40"
              >
                <AvatarContent v-bind:userDetails="userDetails" />
              </v-avatar>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                  <v-avatar
                    :class="{
                      'sokoPrimary font-weight-bold': !userDetails.photourl,
                    }"
                    class="ma-2 ml-0"
                    size="40"
                  >
                    <AvatarContent v-bind:userDetails="userDetails" />
                  </v-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      >{{ userDetails.fname }}
                      {{ userDetails.lname }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      ><small>SokoDelivery&trade;</small></v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item router link to="/user"
                  ><v-list-item-title
                    >Update Profile</v-list-item-title
                  ></v-list-item
                >
                <v-list-item router link to="/delivery"
                  ><v-list-item-title
                    >Schedule Delivery</v-list-item-title
                  ></v-list-item
                >
                <v-list-item router link to="/summary"
                  ><v-list-item-title
                    >Recent Schedules</v-list-item-title
                  ></v-list-item
                >
                <v-list-item @click="logoutDialog = true"
                  ><v-list-item-title>Logout</v-list-item-title></v-list-item
                >
              </v-list>
            </v-card>
          </v-menu>
          <!-- End User button -->
        </template>
        <!-- End -->
      </div>
      <!-- End navbar action components -->

      <v-app-bar-nav-icon
        class="ml-2"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer temporary v-model="drawer" right app>
      <v-list nav dense class="text-uppercase sokoDeep--text">
        <v-list-item>
          <v-spacer></v-spacer>
          <v-btn fab x-small outlined @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item router link to="/about">About Us</v-list-item>
        <div v-if="!isLoggedIn">
          <template v-if="$route.path !== '/auth'">
            <v-list-item @click="openLogin">Login</v-list-item>
            <v-list-item @click="openSignup">Sign up</v-list-item>
          </template>
        </div>

        <template v-else>
          <v-list-item router link to="/user">Profile</v-list-item>
          <v-list-item router link to="/delivery">Delivery</v-list-item>
          <v-list-item router link to="/summary">Summary</v-list-item>
          <v-list-item @click="logoutDialog = true">Logout</v-list-item>
        </template>
        <v-list-item router link to="/faqs">FAQs</v-list-item>
      </v-list>

      <template v-slot:append>
        <PageFooter :side="true" />
      </template>
    </v-navigation-drawer>
    <!-- End navigation drawer -->

    <!-- Authentication form ie. login and signup -->
    <v-dialog v-model="authFormDialog" max-width="500" persistent>
      <AuthForm
        v-bind:authType="authType"
        @closeAuthFormDialog="authFormDialog = false"
        @showSnackbar="onShowSnackbar"
      />
    </v-dialog>
    <!-- End authentication form -->

    <!-- Logout Dialog -->
    <v-dialog v-model="logoutDialog" max-width="290">
      <Logout @closeLogoutDialog="logoutDialog = false" />
    </v-dialog>
    <!-- End Logout Dialog -->
    <v-main :class="{ main: $route.path !== '/' }">
      <router-view v-bind:userDetails="userDetails"></router-view>
    </v-main>

    <WelcomeMessage />
    <!-- <CookieNotifier /> -->
  </v-app>
</template>

<script>
import AuthForm from "@/components/Forms/AuthForm.vue";
import Logout from "@/components/Dialogs/Logout.vue";
import AvatarContent from "@/components/Layout/AvatarContent.vue";
import PageFooter from "@/components/Layout/Home/PageFooter.vue";
import WelcomeMessage from "@/components/Dialogs/WelcomeMessage.vue";
// import CookieNotifier from "@/components/Dialogs/CookieNotifier.vue";

import Push from "push.js";
import { mapActions } from "vuex";

export default {
  name: "App",

  components: {
    AuthForm,
    AvatarContent,
    Logout,
    PageFooter,
    WelcomeMessage,
  },

  data: () => ({
    authType: "login", // login or signup
    authFormDialog: false,
    logoutDialog: false,
    drawer: false,
    isDark: false,

    // Snackbar
    snackbar: false,
    snackbarMsg: "Success!",

    insideApp: true,
  }),

  computed: {
    userDetails() {
      // get current logged in user if user is authenticated
      return this.$store.getters.getCollection("user");
    },
    isLoggedIn() {
      // get current logged in user if user is authenticated
      return this.$store.getters.getAuthenticationStatus;
    },
    appBarProps() {
      return this.$route.name === "Home"
        ? // ? { color: "#f9e2c7", isDark: false }
          { color: "white", isDark: false }
        : { color: "white", isDark: false };
    },
  },

  methods: {
    ...mapActions(["makeFetch", "updateCollection"]),

    openLogin() {
      // open authentication form for login in
      this.authType = "login";
      this.authFormDialog = true;
    },

    openSignup() {
      // open authentication form for sign up
      this.authType = "signup";
      this.authFormDialog = true;
    },

    onShowSnackbar(options) {
      this.snackbarMsg = options.msg;
      this.snackbar = true;
    },

    showNotification(msg) {
      if (!this.insideApp) {
        Push.create("SokoDelivery", {
          body: msg,
          icon: require("./assets/icon.png"),
          timeout: 5000,
          onClick: function() {
            window.focus();
            this.close();
          },
        });
      } else {
        const audio = new Audio(require("@/assets/notification.mp3"));
        audio.play();
        this.snackbarMsg = msg;
        this.snackbar = true;
      }
    },
  },

  sockets: {
    connect() {
      console.log("connected");
    },

    disconnect() {
      console.log("disconnected");
    },

    update(payload) {
      if (
        this.userDetails.uid &&
        this.userDetails.uid === payload.data.current.sokocustomerUid
      ) {
        this.updateCollection(payload);

        // show notification
        this.showNotification(payload.message);
      }
    },
  },

  mounted() {
    this.makeFetch({
      method: "GET",
      goTo: "admin",
      addUrl: "/get-constants/vehicles",
      stateVar: "vehicles",
    });

    window.addEventListener("blur", () => {
      this.insideApp = false;
    });

    window.addEventListener("focus", () => {
      this.insideApp = true;
    });

    if (!Push.Permission.has()) {
      Push.Permission.request();
    }
  },
};
</script>

<style>
* {
  /* font-family: "Poppins", sans-serif; */
  font-family: "ABeeZee", sans-serif;
}

html,
body {
  overflow-x: hidden;
}

.main {
  background-image: url("./assets/sd-background-plain.png");
}

/* Customize scrollbar */
* {
  scrollbar-color: #999 lightgray;
}

/* width */
::-webkit-scrollbar {
  width: 0.4rem;
  padding: 0.02rem;
  background: none;
}

/* track */
::-webkit-scrollbar-track {
  background: lightgray;
}

/* handle */
::-webkit-scrollbar-thumb {
  background: #999;
}

/* handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #777;
}
</style>
